export const filterList = (channels, text) =>
  channels.filter(channel => channel.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);
